module.exports = __webpack_public_path__ + "static/media/theATeam.ac086cf3.jpg";